import { FC } from 'react'
import styled from 'styled-components'

const NewsReactionEmpty: FC = () => {
  return (
    <StyledWrapper>
      <img src="/static/images/channel/recruit.png" alt="enterprise" />
      <span className="empty-title">아직 반응이 없는 소식입니다.</span>
      <span className="empty-desc">
        가장 먼저 반응을 남기고 관심을 표시해보세요.
      </span>
    </StyledWrapper>
  )
}

export default NewsReactionEmpty

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  img {
    height: 92px;
    margin-bottom: 8px;
  }
  .empty-title {
    font-size: 20px;
    font-weight: 500;
    color: #666;
  }
  .empty-desc {
    margin-top: 5px;
    font-size: 15px;
    color: #999;
  }
`
